module.exports = __webpack_public_path__ + "static/media/Airco.a50336e0.mp3";